export default class Observable {
    constructor() {
        this.handlers = null;
    }

    on(event, fn) {
        if (!this.handlers) {
            this.handlers = {};
        }

        let handlers = this.handlers[event];

        if (!handlers) {
            handlers = this.handlers[event] = [];
        }

        handlers.push(fn);

        return {
            name: event,
            callback: fn,
            off: (e, fn) => this.off(e, fn)
        };
    }

    off(event, fn) {
        if (!this.handlers || !this.handlers[event]) {
            return;
        }

        let handlers = this.handlers[event];

        if (fn) {
            handlers = handlers.filter(h => h != fn);
        } else {
            handlers.length = 0;
        }
    }

    fire(event, ...args) {
        if (!this.handlers) return;

        let handlers = this.handlers[event];

        if (!handlers) return;

        handlers.forEach(fn => {
            fn(...args);
        });
    }

    offAll() {
        if (!this.handlers) {
            return;
        }

        for (let prop in this.handlers) {
            if (this.handlers.hasOwnProperty(prop)) {
                this.off(prop);
            }
        }
    }
}
